import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiCheckCircle, FiPackage, FiTruck } from 'react-icons/fi';
import '../styles/OrderSuccess.css';

const OrderSuccess = () => {
  const location = useLocation();
  const { orderId, paymentId, amount, currency = 'INR', paymentMethod = 'Razorpay', items } = location.state || {};

  if (!orderId) {
    return (
      <div className="order-success-page">
        <div className="success-container">
          <div className="error-state">
            <h1>Order Not Found</h1>
            <p>We couldn't find your order details.</p>
            <Link to="/" className="home-btn">Go to Home</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="order-success-page">
      <div className="success-container">
        <div className="success-header">
          <div className="success-icon">
            <FiCheckCircle />
          </div>
          <h1>Order Placed Successfully!</h1>
          <p>Thank you for shopping with Kalinga Crafts Store</p>
        </div>

        <div className="order-details">
          <div className="detail-card">
            <h3>Order Information</h3>
            <div className="detail-row">
              <span>Order ID:</span>
              <strong>{orderId}</strong>
            </div>
            <div className="detail-row">
              <span>Payment ID:</span>
              <strong>{paymentId}</strong>
            </div>
            <div className="detail-row">
              <span>Total Amount:</span>
              <strong>{currency === 'INR' ? '₹' : '$'}{amount?.toLocaleString(currency === 'INR' ? 'en-IN' : 'en-US')}</strong>
            </div>
            <div className="detail-row">
              <span>Payment Method:</span>
              <strong>{paymentMethod}</strong>
            </div>
            <div className="detail-row">
              <span>Currency:</span>
              <strong>{currency}</strong>
            </div>
            <div className="detail-row">
              <span>Payment Status:</span>
              <span className="status success">Paid</span>
            </div>
          </div>

          <div className="detail-card">
            <h3>Order Summary</h3>
            <div className="order-items">
              {items?.map((item) => (
                <div key={item.id} className="order-item">
                  <img src={item.image} alt={item.name} className="item-image" />
                  <div className="item-info">
                    <h4>{item.name}</h4>
                    <p>Quantity: {item.quantity}</p>
                    <p className="price">₹{(item.price * item.quantity).toLocaleString('en-IN')}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="delivery-info">
            <div className="info-card">
              <FiPackage />
              <div>
                <h4>Order Confirmed</h4>
                <p>Your order has been confirmed and is being processed.</p>
              </div>
            </div>

            <div className="info-card">
              <FiTruck />
              <div>
                <h4>Estimated Delivery</h4>
                <p>3-5 business days. You'll receive tracking updates via email.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="success-actions">
          <Link to="/products" className="continue-shopping-btn">
            Continue Shopping
          </Link>
          <Link to="/account" className="view-orders-btn">
            View My Orders
          </Link>
        </div>

        <div className="support-info">
          <p>Need help? Contact our support team at <a href="mailto:support@kalingastore.shop">support@kalingastore.shop</a></p>
          <p>Order questions? Call us at <a href="tel:+91-1800-XXX-XXXX">+91-1800-XXX-XXXX</a></p>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccess;